<template>
  <div class="container" v-wechat-title="$route.meta.title">
    <!-- 库存报表 -->
    <div class="onePart">
      <div
        v-if="changeIndex == 0"
        v-bind:class="{ day:changeIndex== 0,'date-bar':1}"
      >{{showDate(beginDay)}}</div>
      <div v-if="changeIndex == 2" class="date-bar">
        {{showDate(beginDay,'y')}}
        <span @click="selectDate('sub')">&lt;&lt;</span>
        {{showDate(beginDay,'m')}}
        <span @click="selectDate('add')">&gt;&gt;</span>
      </div>
      <div v-if="changeIndex == 1" class="date-bar">
        {{showDate(beginDay,'y')}}
        <span @click="selectDate('sub')">&lt;&lt;</span>
        {{showDate(beginDay,'d')}} - {{showDate(endDay,'d')}}
        <span
          @click="selectDate('add')"
        >&gt;&gt;</span>
      </div>
      <div class="topChange disp-just-aro-ali-cen">
        <div @click="changeType" :index="0" :class="[changeIndex==0?'div1':'div2']">今日</div>
        <div @click="changeType" :index="1" :class="[changeIndex==1?'div1':'div2']">周报</div>
        <div @click="changeType" :index="2" :class="[changeIndex==2?'div1':'div2']">月报</div>
      </div>
      <div class="wrap disp-ali-cen">
        <template v-if="changeIndex == 0">
          <div class="info info4 disp-just-aro-ali-cen-fldir-col">
            <div class="div-relative">今日入库货值（元）<p @click="checkQues('今日入库货值_'+(changeIndex+1))" class="ques"></p></div>
            <div>
              <span style="font-size: 0.34rem;">￥</span>
              {{getOneDimension("入库总货值",0)}}
            </div>
            <div>昨日入库货值：￥{{getOneDimension("昨日入库总货值",0)}}</div>
          </div>
          <div class="info info4 disp-just-aro-ali-cen-fldir-col">
            <div class="div-relative">今日出库货值（元）<p @click="checkQues('今日出库货值_'+(changeIndex+1))" class="ques"></p></div>
            <div>
              <span style="font-size: 0.34rem;">￥</span>
              {{getOneDimension("出库总货值",0)}}
            </div>
            <div>昨日出库货值：￥{{getOneDimension("昨日出库总货值",0)}}</div>
          </div>
          <div class="info info_1 info4 disp-just-aro-ali-cen-fldir-col">
            <div class="div-relative">库存总货值（元）<p @click="checkQues('库存总货值_'+(changeIndex+1))" class="ques"></p></div>
            <div>
              <span style="font-size: 0.34rem;">￥</span>
              {{getOneDimension("库存总货值",0)}}
            </div>
            <div>{{LastTime}}</div>
          </div>
        </template>
      </div> 
    </div>
    <!-- 商品大类库存数量 -->
    <div class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        商品大类库存数量（件）<p @click="checkQues('商品大类库存数量_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="barOne" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
    <!-- 商品大类库存货值 -->
    <div  class="onePart">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">
        商品大类库存货值（元）<p @click="checkQues('商品大类库存货值_'+(changeIndex+1))" class="ques2"></p>
      </div>
      <div id="barTwo" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>

    <!-- <div v-if="changeIndex > 0" class="info info4 disp-just-aro-ali-cen-fldir-col">
      <div class="div-relative">入库货值（元）<p @click="checkQues('入库货值_'+(changeIndex+1))" class="ques"></p></div>
      <div>
        <span style="font-size: 0.34rem;">￥</span>
        {{getOneDimension("入库总货值",0)}}
      </div>
      <div style="opacity: 0;">昨日入库货值：￥2</div>
    </div>
    <div v-if="changeIndex > 0" class="info  info4 disp-just-aro-ali-cen-fldir-col">
      <div class="div-relative">出库货值（元）<p @click="checkQues('出库货值_'+(changeIndex+1))" class="ques"></p></div>
      <div>
        <span style="font-size: 0.34rem;">￥</span>
        {{getOneDimension("出库总货值",0)}}
      </div>
      <div style="opacity: 0;">昨日预约到店：2</div>
    </div> -->

    <!-- 入库货值趋势 -->
    <div class="onePart" v-if="changeIndex > 0">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">入库货值趋势（元）<p @click="checkQues('入库货值趋势_'+(changeIndex+1))" class="ques2"></p></div>
      <div id="categoryOne" :style="{width:'100%',height:'5.06rem'}"></div>
    </div>
    <!-- 出库货值趋势 -->
    <div class="onePart" v-if="changeIndex > 0">
      <div class="titlePart disp-just-flsta-ali-cen div-relative">出库货值趋势（元）<p @click="checkQues('出库货值趋势_'+(changeIndex+1))" class="ques2"></p></div>
      <div id="categoryTwo" :style="{width:'100%',height:'5.06rem'}"></div>
     </div>
    <div class="divPlaceholder">&nbsp;</div>
    <Loading v-show="loadShow"></Loading>
    <popupWin v-if="popupIsShow" :popupShow="isPopupShow" :keyWords="keyWord" @childRe="childReturn"></popupWin>
  </div>
</template>
<script>
import Vue from "vue";
import util from "../../static/js/util";
import { Toast } from "vant";
Vue.use(Toast);
import baseUrl from "../../static/js/basedata.js";
import { Loading } from "vant";
Vue.use(Loading);

export default {
  name: "InfoPage",
  data() {
    return {
      changeIndex: 0,
      beginDay: new Date(),
      endDay: new Date(),
      RptData: {},
      loadShow: false,
      show: false,
      minDate: new Date(),
      maxDate: new Date(2999, 1, 1),
      isPopupShow: false,
      keyWord:'',//带入组件关键字
      popupIsShow:false,
      popupShow:false,//底部弹框是否显示
      keyWords:'',
      popupTitle:'弹框标题',//弹框标题
      popupContent:'弹框内容',//弹框标题
  };
  },
  computed: {
    getDate: function() {
      if (this.changeIndex == 0) {
        return this.formatDate(new Date(this.beginDay));
      } else {
        return `${this.formatDate(new Date(this.beginDay))} - ${this.formatDate(
          new Date(this.endDay)
        )}`;
      }
    },
    LastTime: function() {
            if (this.RptData.LastUpdateTime){
             var timeS = this.RptData.LastUpdateTime.replace(/-/g,"/"); 
                return (
                    "更新时间:" +
                    new Date(timeS).format("MM/dd hh:mm")
                );}
            return "";
        }
  },
  methods: {
    checkQues(_key){
      console.log(_key)
      this.isPopupShow = true;
      this.keyWord = _key;
      this.popupIsShow = true;
    },
    childReturn(data){
      console.log('data-----',data)
      this.isPopupShow = data;
      this.popupIsShow = data;
    },
    formatDate(date) {
      // 今日选择
      if (this.changeIndex == 0) {
        return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
      } else if (this.changeIndex == 1) {
        // 周选择
        return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
      } else if (this.changeIndex == 2) {
        // 月选择
        return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
      }
    },
    showDate(date, mode) {
      // 今日选择
      mode = mode || "a";
      date = new Date(date);
      if (this.changeIndex == 0) {
        return `${date.getFullYear()}年${date.getMonth() +
          1}月${date.getDate()}日`;
      } else if (this.changeIndex == 1) {
        if (mode === "y") {
          return `${date.getFullYear()}年`;
        }
        if (mode === "d") return `${date.getMonth() + 1}月${date.getDate()}日`;
      } else if (this.changeIndex == 2) {
        // 月选择
        if (mode === "y") {
          return `${date.getFullYear()}年`;
        }
        if (mode === "m") return `${date.getMonth() + 1}月`;
      }
    },
    selectDate(mode) {
      if (this.changeIndex == 2) {
        if (mode === "add") {
          var date = new Date(this.beginDay);
          date.setDate(1);
          date.setMonth(date.getMonth() + 1);
          this.beginDay = date.format("yyyy-MM-dd");
          var date = new Date(this.beginDay);
          date.setMonth(date.getMonth() + 1);
          date.setDate(0);
          this.endDay = date.format("yyyy-MM-dd");
        } else if (mode === "sub") {
          var date = new Date(this.beginDay);
          date.setDate(1);
          date.setMonth(date.getMonth() - 1);
          this.beginDay = date.format("yyyy-MM-dd");
          var date = new Date(this.beginDay);
          date.setMonth(date.getMonth() + 1);
          date.setDate(0);
          this.endDay = date.format("yyyy-MM-dd");
        }
        this.loadData();
      }
      if (this.changeIndex == 1) {
        if (mode === "add") {
          var date = new Date(this.beginDay);
          date.setDate(date.getDate() + 7);
          this.beginDay = date.format("yyyy-MM-dd");
          var date = new Date(this.beginDay);
          date.setDate(date.getDate() + 6);
          this.endDay = date.format("yyyy-MM-dd");
        } else if (mode === "sub") {
          var date = new Date(this.beginDay);
          date.setDate(date.getDate() - 7);
          this.beginDay = date.format("yyyy-MM-dd");
          var date = new Date(this.beginDay);
          date.setDate(date.getDate() + 6);
          this.endDay = date.format("yyyy-MM-dd");
        }
        this.loadData();
      }
    },
    onConfirm(date) {
      if (this.changeIndex == 0) {
        this.beginDay = date.format("yyyy-MM-dd");
        this.endDay = date.format("yyyy-MM-dd");
      } else {
        const [start, end] = date;
        this.beginDay = start.format("yyyy-MM-dd");
        this.endDay = end.format("yyyy-MM-dd");
      }
      this.loadData();
    },
    changeType(e) {
      var index = e.target.getAttribute("index");
      this.changeIndex = Number(index);
      var date = this.$dateUtil.today();
      switch (this.changeIndex) {
        case 0:
          date = this.$dateUtil.today();
          break;
        case 1:
          date = this.$dateUtil.thisWeek();
          break;
        case 2:
          date = this.$dateUtil.thisMonth();
          break;
      }
      this.beginDay = date.Begin;
      this.endDay = date.End;
      this.loadData();
    },
    loadData() {
      var that = this;
      that.loadShow = true;
      that.show = false;
      var query = {
        ReportType: that.$util.AppReportType.库存报表,
        Begin: that.beginDay,
        End: that.endDay
      };
      this.$api.get(
        "/AppReport",
        query,
        function(res) {
          that.RptData = res;
          that.drawPie();
          that.loadShow = false;
        },
        function(err) {
          that.loadShow = false;
        }
      );
    },
    getOneDimension(subTypeName, def) {
      return this.$util.getOneDimension(this.RptData.Items, subTypeName, def);
    },
    getTwoDimension(subTypeName, defX, defY) {
      return this.$util.getTwoDimension(
        this.RptData.Items,
        subTypeName,
        defX,
        defY
      );
    },
    getTwoDimensionBar(subTypeName, defY, defValue, valueColumn) {
      return this.$util.getTwoDimensionBar(
        this.RptData.Items,
        subTypeName,
        defY,
        defValue,
        valueColumn
      );
    },
    drawPie() {
    
      if (this.changeIndex > 0) {
        var categoryOneData = this.getTwoDimensionBar(
          "单日入库总货值",
          "货值",
          "0"
        );
        this.$echarts
          .init(document.getElementById("categoryOne"))
          .setOption(this.$util.LineOption(categoryOneData));

        var categoryTwoData = this.getTwoDimensionBar(
          "单日出库总货值",
          "货值",
          "0"
        );
        this.$echarts
          .init(document.getElementById("categoryTwo"))
          .setOption(this.$util.LineOption(categoryTwoData));
      }

       var barOneData = this.getTwoDimensionBar("商品大类库存数量", "其他", "0");
        this.$echarts.init(document.getElementById('barOne')).setOption(
            this.$util.BarOption(barOneData,"商品大类")
        );
         var barTwoData = this.getTwoDimensionBar("商品大类库存货值", "其他", "0");
        this.$echarts.init(document.getElementById('barTwo')).setOption(
            this.$util.BarOption(barTwoData,"商品大类")
        );

    }
  },
  mounted() {
    var date = this.$dateUtil.today();
    this.beginDay = date.Begin;
    this.endDay = date.End;
    this.loadData();
    phoneDevice.setTitle(this.$route.meta.title || "");
  }
};
</script>

<style>
@import url("../../static/css/common.css");
.topChange {
  width: 100%;
  margin-bottom: 0.53rem;
}

.topChange .div1 {
  width: auto;
  font-size: 0.34rem;
  color: #1c1c1c;
  border-bottom: 0.05rem solid #1699e5;
}

.topChange .div2 {
  width: auto;
  font-size: 0.34rem;
  color: #999999;
  border-bottom: 0.05rem solid transparent;
}

.container {
  width: 10rem;
  min-height: 100vh;
  background: #f2f2f2;
  /* background: pink; */
  padding: 0 0.34rem;
  box-sizing: border-box;
  border-top: 0.01rem solid transparent;
}
.wrap .info1 {
  background-image: url(../assets/indexImage/img10.png);
}

.wrap .info2 {
  background-image: url(../assets/indexImage/img2.png);
}

.wrap .info3 {
  background-image: url(../assets/indexImage/img4.png);
}

.wrap .info4 {
  background-image: url(../assets/indexImage/img6.png);
}

.wrap .info5 {
  background-image: url(../assets/indexImage/img12.png);
}

.wrap .info6 {
  background-image: url(../assets/indexImage/img8.png);
}

</style>



// WEBPACK FOOTER //
// src/components/kucunbaobiao.vue